import { CommandBase, getByIdPath, MicroTaskConfig, urlCombine } from 'ihub/common';
import {
	getTenantID,
	handleResponse,
	microServiceAPI,
	standardPost,
} from '../classes/http-helper-const';
import dispatchSnackbar from '../functions/dispatch-snackbar';
import HttpResponseOptions from '../interface/http-response-options';
import QueryClientWrapper from '../utils/create-query-client';

export class ExecutionSimulatorHttpService {
	protected readonly controllerName = `ExecutionSimulator`;
	protected readonly simulateFlowPath = 'SimulateFlow';
	protected readonly simulateTaskPath = 'SimulateTask';

	async simulateFlow(command: CommandBase, options?: HttpResponseOptions) {
		const url = urlCombine(microServiceAPI, this.controllerName, this.simulateFlowPath);
		const response = await standardPost(url, command);
		await handleResponse(response, 'Simulate Flow', this.controllerName, options);
	}

	async simulateTask(command: CommandBase, options?: HttpResponseOptions) {
		const url = urlCombine(microServiceAPI, this.controllerName, this.simulateTaskPath);
		try {
			const response = await standardPost(url, command);
			await QueryClientWrapper.InvalidateKey(
				[getTenantID(), MicroTaskConfig.name, getByIdPath, command.pattern.taskID],
				false
			);
			await handleResponse(response, 'Simulate Task', this.controllerName, options);
		} catch (error) {
			const err = error as Error;
			if (options?.error) {
				options.error(err);
			} else {
				dispatchSnackbar({
					message: `Failed to send simulate task request - ${err.message}`,
					severity: 'error',
				});
			}
		}
	}
}
